export { default as Img200 } from './processed/200/Jupiter-Ascending.jpg';
export { default as Img400 } from './processed/400/Jupiter-Ascending.jpg';
export { default as Imgthumb } from './processed/thumb/Jupiter-Ascending.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Jupiter-Ascending.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Jupiter-Ascending.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      169,
      99,
      50
    ],
    "_population": 44,
    "_hsl": [
      0.06862745098039216,
      0.54337899543379,
      0.4294117647058823
    ]
  },
  "LightVibrant": {
    "_rgb": [
      229,
      190,
      137
    ],
    "_population": 311,
    "_hsl": [
      0.09601449275362318,
      0.6388888888888888,
      0.7176470588235294
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      92,
      52,
      20
    ],
    "_population": 5,
    "_hsl": [
      0.07407407407407407,
      0.6428571428571429,
      0.2196078431372549
    ]
  },
  "Muted": {
    "_rgb": [
      173,
      135,
      100
    ],
    "_population": 2398,
    "_hsl": [
      0.07990867579908675,
      0.3080168776371308,
      0.5352941176470588
    ]
  },
  "LightMuted": {
    "_rgb": [
      211,
      189,
      166
    ],
    "_population": 1145,
    "_hsl": [
      0.08518518518518524,
      0.33834586466165395,
      0.7392156862745098
    ]
  },
  "DarkMuted": {
    "_rgb": [
      65,
      49,
      36
    ],
    "_population": 2749,
    "_hsl": [
      0.07471264367816095,
      0.2871287128712871,
      0.1980392156862745
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Jupiter-Ascending.js